import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorderRadius } from 'Components/utils';
import useMobileLayout from 'Hooks/useMobileLayout';

export const MOBILE_PAPER_SPACING = 16;
export const DESKTOP_PAPER_SPACING = 32;

const useStyles = buildUseStyles('ImpactPaper', (theme) => ({
  // Paper color=info is the wrong color, so this is the substitute
  root: {
    background: theme.palette.facet.oceana50,
    display: 'flex',
    flex: 1,
    padding: MOBILE_PAPER_SPACING,
    justifyContent: 'center',
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  rootDesktop: {
    minWidth: theme.dimensions.sm,
    padding: DESKTOP_PAPER_SPACING,
  },
}));

export function ImpactPaper({ children }) {
  const classes = useStyles();
  const isMobile = useMobileLayout();
  return <div className={classNames(classes.root, { [classes.rootDesktop]: !isMobile })}>{children}</div>;
}

ImpactPaper.propTypes = {
  children: PropTypes.node.isRequired,
};
